import type { FC } from 'react';
import { Link } from '@compat/router';
import { Picture } from '@ui';
import { observer } from 'mobx-react';
import icons from '@icons';
import './index.scss';
import { preparePriceFloatObject } from '@utils/floatNumbers';
import { useStores } from '@root/src/stores';

const {
  cart: { black: cartBlackFilled, red: cartRedFilled }
} = icons.Fill;

interface CartBtnProps {
  linkTo?: string;
  hideMiniCart?: () => void;
  isDesktop?: boolean;
  isShow?: boolean;
  isBarMenu?: boolean;
}

const CartBtn: FC<CartBtnProps> = observer(
  ({ linkTo = '/cart', hideMiniCart, isDesktop, isShow }) => {
    const { cartStore } = useStores();
    const cart = cartStore?.cart;
    const totalAmount =
      !!cart?.items?.length &&
      (
        cart.items as Array<{
          amount: number;
        }>
      ).reduce((acc, item) => acc + Number(item?.amount || 0), 0);
    const total = preparePriceFloatObject(cart?.total || 0);
    return (
      <Link className={'cart-btn'} to={linkTo} onClick={hideMiniCart}>
        <div className='cart-btn__icon'>
          <Picture
            icon={isShow && isDesktop ? cartRedFilled : cartBlackFilled}
            height={isDesktop ? '20' : '24'}
            width={isDesktop ? '20' : '24'}
          />
          {!!cart?.items?.length && (
            <span className='cart-btn__count-goods'>{totalAmount}</span>
          )}
        </div>
        {Number(cart?.total) > 0 && (
          <div className='cart-btn__total'>
            {total?.wholePart}
            {total?.floatPart && (
              <span className='cart-btn__decimal'>,{total?.floatPart}</span>
            )}{' '}
            <span className='cart-btn__ruble'>₽</span>
          </div>
        )}
      </Link>
    );
  }
);

export default CartBtn;
